import React from 'react';
import {ConfirmMessageIcon} from "../../../assets/icons/Icons";
import Message from "../../Message";
import {useTranslation} from "react-i18next";

const CardHolderCreationMessage = () => {
    const { t } = useTranslation();
    return (
        <div className="step">
            <div className="multistep-form-confirmation-message">
                <h2 className="multistep-form-confirmation-message__title"><span
                    className="multistep-form-confirmation-message__title--icon"><ConfirmMessageIcon/></span> {t("Card Creation Submitted")}
                </h2>
                <Message type="message-success" message={<><p>{t("Your card creation request has been submitted.")}</p></>}/>
            </div>
        </div>
    );
};

export default CardHolderCreationMessage;
